import { connect } from 'react-redux';
import PasswordPage from '../../components/PasswordPage';

export default connect()(PasswordPage);
